"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PromotionPerformanceRowSupplierInfo_1 = require("./PromotionPerformanceRowSupplierInfo");
/**
 * @author BPo
 * @author Radek Beran
 */


var WindowPerformanceReportRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowPerformanceReportRowDTO, _DomainObject_1$Domai);

  /**
   * @param id unique internal id
   * @param nodeId Id based on origin entity
   * @param reportId
   * @param level
   * @param treeLevel
   * @param isGroup Flag that says if entity have children
   * @param entity Name of origin entity ( eg. WindowItem.name)
   * @param entityId
   * @param title Title based on origin entity ( eg. WindowItem.name )
   * @param isDummy Flag that says if entity is dummy
   * @param skuCount
   * @param ud
   * @param department
   * @param scm
   * @param fcApprovalNeeded
   * @param fcRisk
   * @param cm
   * @param category
   * @param category4box
   * @param promoExternalId
   * @param promoName
   * @param windowTypeId
   * @param windowTypeName
   * @param windowOriginId
   * @param windowName
   * @param windowDateFrom
   * @param windowItemId
   * @param supplierId
   * @param supplierName
   * @param windowWorkflowState
   * @param storeSpecification
   * @param posMechanics
   * @param posAction
   * @param promoTypeId
   * @param promoTypeName
   * @param validDays
   * @param products
   * @param creditsEnabled
   * @param creditsAmountForPurchase
   * @param creditsHealthyAmountForPurchase
   * @param creditsPurchaseQuantity
   * @param regularPrice
   * @param promoPrice
   * @param promoPriceLevel
   * @param promoDiscount
   * @param promoVolume
   * @param promoDateFrom
   * @param posMarginImpact
   * @param productId
   * @param leafletFee
   * @param secondaryPlacementFee
   * @param requestForSecondaryPlacement
   * @param secondaryPlacement
   * @param onPicture
   * @param numberOfSites
   * @param supplierCurrency
   * @param promoPurchaseStartDate
   * @param promoPurchaseEndDate
   * @param costPriceFormat
   * @param promoPurchasePrice
   * @param promoPurchasePriceCZK
   * @param regularPurchasePrice
   * @param regularPurchasePriceCZK
   * @param promoPurchasePricePlus
   * @param promoPurchasePricePlusCZK
   * @param kpiSegmentationRealName
   * @param kpiSegmentationUserName
   * @param kpiSegmentationSystemName
   * @param kpiValues
   * @param logisticComment
   * @param unitBackDiscount
   * @param nonPreferredSupplierIncluded
   * @param supplierInfos {@link PromotionPerformanceRowSupplierInfo} information about suppliers
   * @param vatRate
   */
  function WindowPerformanceReportRowDTO(id, nodeId, reportId, level, treeLevel, isGroup, entity, entityId, title, isDummy, skuCount, ud, department, scm, fcApprovalNeeded, fcRisk, cm, category, category4box, promoExternalId, promoName, windowTypeId, windowTypeName, windowOriginId, windowName, windowDateFrom, windowItemId, supplierId, supplierName, windowWorkflowState, storeSpecification, posMechanics, posAction, promoTypeId, promoTypeName, validDays, products, creditsEnabled, creditsAmountForPurchase, creditsHealthyAmountForPurchase, creditsPurchaseQuantity, regularPrice, promoPrice, promoPriceLevel, promoDiscount, promoVolume, promoDateFrom, posMarginImpact, productId, // LOG-7398 RFC-361
  leafletFee, secondaryPlacementFee, //RFC-377
  requestForSecondaryPlacement, secondaryPlacement, onPicture, numberOfSites, supplierCurrency, promoPurchaseStartDate, promoPurchaseEndDate, costPriceFormat, promoPurchasePrice, promoPurchasePriceCZK, regularPurchasePrice, regularPurchasePriceCZK, promoPurchasePricePlus, promoPurchasePricePlusCZK, // kpi
  kpiSegmentationRealName, kpiSegmentationUserName, kpiSegmentationSystemName, kpiValues, // PROMO-397
  logisticComment, unitBackDiscount,
  /** PROMO-463 - saved basic information about all suppliers */
  nonPreferredSupplierIncluded, supplierInfos, vatRate) {
    var _this;

    _classCallCheck(this, WindowPerformanceReportRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowPerformanceReportRowDTO).call(this));
    _this.id = id;
    _this.nodeId = nodeId;
    _this.reportId = reportId;
    _this.level = level;
    _this.treeLevel = treeLevel;
    _this.isGroup = isGroup;
    _this.entity = entity;
    _this.entityId = entityId;
    _this.title = title;
    _this.isDummy = isDummy;
    _this.skuCount = skuCount;
    _this.ud = ud;
    _this.department = department;
    _this.scm = scm;
    _this.fcApprovalNeeded = fcApprovalNeeded;
    _this.fcRisk = fcRisk;
    _this.cm = cm;
    _this.category = category;
    _this.category4box = category4box;
    _this.promoExternalId = promoExternalId;
    _this.promoName = promoName;
    _this.windowTypeId = windowTypeId;
    _this.windowTypeName = windowTypeName;
    _this.windowOriginId = windowOriginId;
    _this.windowName = windowName;
    _this.windowDateFrom = windowDateFrom;
    _this.windowItemId = windowItemId;
    _this.supplierId = supplierId;
    _this.supplierName = supplierName;
    _this.windowWorkflowState = windowWorkflowState;
    _this.storeSpecification = storeSpecification;
    _this.posMechanics = posMechanics;
    _this.posAction = posAction;
    _this.promoTypeId = promoTypeId;
    _this.promoTypeName = promoTypeName;
    _this.validDays = validDays;
    _this.products = products;
    _this.creditsEnabled = creditsEnabled;
    _this.creditsAmountForPurchase = creditsAmountForPurchase;
    _this.creditsHealthyAmountForPurchase = creditsHealthyAmountForPurchase;
    _this.creditsPurchaseQuantity = creditsPurchaseQuantity;
    _this.regularPrice = regularPrice;
    _this.promoPrice = promoPrice;
    _this.promoPriceLevel = promoPriceLevel;
    _this.promoDiscount = promoDiscount;
    _this.promoVolume = promoVolume;
    _this.promoDateFrom = promoDateFrom;
    _this.posMarginImpact = posMarginImpact;
    _this.productId = productId;
    _this.leafletFee = leafletFee;
    _this.secondaryPlacementFee = secondaryPlacementFee;
    _this.requestForSecondaryPlacement = requestForSecondaryPlacement;
    _this.secondaryPlacement = secondaryPlacement;
    _this.onPicture = onPicture;
    _this.numberOfSites = numberOfSites;
    _this.supplierCurrency = supplierCurrency;
    _this.promoPurchaseStartDate = promoPurchaseStartDate;
    _this.promoPurchaseEndDate = promoPurchaseEndDate;
    _this.costPriceFormat = costPriceFormat;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.promoPurchasePriceCZK = promoPurchasePriceCZK;
    _this.regularPurchasePrice = regularPurchasePrice;
    _this.regularPurchasePriceCZK = regularPurchasePriceCZK;
    _this.promoPurchasePricePlus = promoPurchasePricePlus;
    _this.promoPurchasePricePlusCZK = promoPurchasePricePlusCZK;
    _this.kpiSegmentationRealName = kpiSegmentationRealName;
    _this.kpiSegmentationUserName = kpiSegmentationUserName;
    _this.kpiSegmentationSystemName = kpiSegmentationSystemName;
    _this.kpiValues = kpiValues;
    _this.logisticComment = logisticComment;
    _this.unitBackDiscount = unitBackDiscount;
    _this.nonPreferredSupplierIncluded = nonPreferredSupplierIncluded;
    _this.supplierInfos = supplierInfos;
    _this.vatRate = vatRate;
    return _this;
  }

  return WindowPerformanceReportRowDTO;
}(DomainObject_1.DomainObject);

exports.WindowPerformanceReportRowDTO = WindowPerformanceReportRowDTO;

WindowPerformanceReportRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowPerformanceReportRowDTO.name);
  return {
    id: builder.str('id'),
    nodeId: builder.str('nodeId'),
    reportId: builder.str('reportId'),
    level: builder.num('level'),
    treeLevel: builder.num('treeLevel'),
    isGroup: builder.bool('isGroup'),
    entity: builder.opt(builder.str('entity')),
    entityId: builder.opt(builder.str('entityId')),
    title: builder.opt(builder.str('title')),
    isDummy: builder.opt(builder.bool('isDummy')),
    skuCount: builder.opt(builder.num('skuCount')),
    ud: builder.opt(builder.listOf(builder.str('ud'))),
    department: builder.opt(builder.str('department')),
    scm: builder.opt(builder.str('scm')),
    fcApprovalNeeded: builder.opt(builder.bool('fcApprovalNeeded')),
    fcRisk: builder.opt(builder.bool('fcRisk')),
    cm: builder.opt(builder.str('cm')),
    category: builder.opt(builder.str('category')),
    category4box: builder.opt(builder.str('category4box')),
    promoExternalId: builder.opt(builder.str('promoExternalId')),
    promoName: builder.opt(builder.str('promoName')),
    windowTypeId: builder.opt(builder.str('windowTypeId')),
    windowTypeName: builder.opt(builder.str('windowTypeName')),
    windowOriginId: builder.opt(builder.str('windowOriginId')),
    windowName: builder.opt(builder.str('windowName')),
    windowDateFrom: builder.opt(builder.date('windowDateFrom')),
    windowItemId: builder.opt(builder.str('windowItemId')),
    supplierId: builder.opt(builder.str('supplierId')),
    supplierName: builder.opt(builder.str('supplierName')),
    windowWorkflowState: builder.opt(builder.str('windowWorkflowState')),
    storeSpecification: builder.opt(builder.str('storeSpecification')),
    posMechanics: builder.opt(builder.str('posMechanics')),
    posAction: builder.opt(builder.str('posAction')),
    promoTypeId: builder.opt(builder.str('promoTypeId')),
    promoTypeName: builder.opt(builder.str('promoTypeName')),
    validDays: builder.opt(builder.num('validDays')),
    products: builder.opt(builder.str('products')),
    creditsEnabled: builder.opt(builder.bool('creditsEnabled')),
    creditsAmountForPurchase: builder.opt(builder.num('creditsAmountForPurchase')),
    creditsHealthyAmountForPurchase: builder.opt(builder.num('creditsHealthyAmountForPurchase')),
    creditsPurchaseQuantity: builder.opt(builder.num('creditsPurchaseQuantity')),
    regularPrice: builder.opt(builder.bigNum('regularPrice')),
    promoPrice: builder.opt(builder.bigNum('promoPrice')),
    promoPriceLevel: builder.opt(builder.num('promoPriceLevel')),
    promoDiscount: builder.opt(builder.bigNum('promoDiscount')),
    promoVolume: builder.opt(builder.bigNum('promoVolume')),
    promoDateFrom: builder.opt(builder.date('promoDateFrom')),
    posMarginImpact: builder.opt(builder.bigNum('posMarginImpact')),
    productId: builder.opt(builder.str('productId')),
    leafletFee: builder.opt(builder.bigNum('leafletFee')),
    secondaryPlacementFee: builder.opt(builder.bigNum('secondaryPlacementFee')),
    //RFC-377
    requestForSecondaryPlacement: builder.opt(builder.bool('requestForSecondaryPlacement')),
    secondaryPlacement: builder.opt(builder.str('secondaryPlacement')),
    onPicture: builder.opt(builder.bool('onPicture')),
    numberOfSites: builder.opt(builder.num('numberOfSites')),
    supplierCurrency: builder.opt(builder.str('supplierCurrency')),
    promoPurchaseStartDate: builder.opt(builder.date('promoPurchaseStartDate')),
    promoPurchaseEndDate: builder.opt(builder.date('promoPurchaseEndDate')),
    costPriceFormat: builder.opt(builder.str('costPriceFormat')),
    promoPurchasePrice: builder.opt(builder.bigNum('promoPurchasePrice')),
    promoPurchasePriceCZK: builder.opt(builder.bigNum('promoPurchasePriceCZK')),
    regularPurchasePrice: builder.opt(builder.bigNum('regularPurchasePrice')),
    regularPurchasePriceCZK: builder.opt(builder.bigNum('regularPurchasePriceCZK')),
    promoPurchasePricePlus: builder.opt(builder.bigNum('promoPurchasePricePlus')),
    promoPurchasePricePlusCZK: builder.opt(builder.bigNum('promoPurchasePricePlusCZK')),
    //KPI
    kpiSegmentationRealName: builder.opt(builder.str('kpiSegmentationRealName')),
    kpiSegmentationUserName: builder.opt(builder.str('kpiSegmentationUserName')),
    kpiSegmentationSystemName: builder.opt(builder.str('kpiSegmentationSystemName')),
    kpiValues: builder.opt(builder.smap(builder.bigNum('kpiValues'))),
    // PROMO-397
    logisticComment: builder.opt(builder.str('logisticComment')),
    unitBackDiscount: builder.opt(builder.bigNum('unitBackDiscount')),
    nonPreferredSupplierIncluded: builder.opt(builder.bool('nonPreferredSupplierIncluded')),
    supplierInfos: builder.opt(builder.listOf(builder.obj('supplierInfos', PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo.schema, function (mat) {
      return PromotionPerformanceRowSupplierInfo_1.PromotionPerformanceRowSupplierInfo.fromDataDict(mat);
    }))),
    vatRate: builder.opt(builder.bigNum('vatRate'))
  };
}();